import { localTime } from '@helpers';
import { DATE_FORMAT } from '@v2/pages/common/constants/base.constants';
import { TimePeriod } from '@v2/pages/machines/common/enums';
import { DateRangeResult } from '@components/machines/components/eventsChart/types';
import { getEightWeeksWindow } from './period';

export const getDateRangeForPeriod = (selectedTime: string, selectedChartDate?: string): DateRangeResult | null => {
  let momentStart = localTime();
  let momentEnd = localTime();
  if (selectedChartDate) {
    momentStart = localTime(selectedChartDate);
    momentEnd = localTime(selectedChartDate);
  }

  switch (selectedTime) {
    case TimePeriod.DAY: {
      const start = momentStart.clone().startOf('day');
      const end = momentEnd.clone().add(1, 'day').startOf('day');
      const startPrev = momentStart.clone().subtract(1, 'week').startOf('day');
      const endPrev = momentEnd.clone().subtract(1, 'week').add(1, 'day').startOf('day');

      return {
        start: start.format(DATE_FORMAT),
        end: end.format(DATE_FORMAT),
        startPrev: startPrev.format(DATE_FORMAT),
        endPrev: endPrev.format(DATE_FORMAT),
        amount: 24,
        amountPrev: 24,
        period: 'hour',
        usesSingleApiCall: false,
      };
    }
    case TimePeriod.WEEK: {
      const start = momentStart.clone().startOf('isoWeek');
      const end = momentEnd.clone().add(1, 'isoWeek').startOf('isoWeek');
      const startPrev = momentStart.clone().subtract(1, 'isoWeek').startOf('isoWeek');
      const endPrev = start.clone();

      return {
        start: start.format(DATE_FORMAT),
        end: end.format(DATE_FORMAT),
        startPrev: startPrev.format(DATE_FORMAT),
        endPrev: endPrev.format(DATE_FORMAT),
        amount: 7 * 24,
        amountPrev: 7 * 24,
        period: 'hour',
        usesSingleApiCall: true,
      };
    }
    case TimePeriod.MONTH: {
      const start = momentStart.clone().startOf('month');
      const end = momentEnd.clone().add(1, 'month').startOf('month');
      const startPrev = momentStart.clone().subtract(1, 'month').startOf('month');
      const endPrev = start.clone();
      const amount = momentStart.daysInMonth();
      const amountPrev = momentStart.clone().subtract(1, 'month').daysInMonth();

      return {
        start: start.format(DATE_FORMAT),
        end: end.format(DATE_FORMAT),
        startPrev: startPrev.format(DATE_FORMAT),
        endPrev: endPrev.format(DATE_FORMAT),
        amount,
        amountPrev,
        period: 'day',
        usesSingleApiCall: true,
      };
    }
    case TimePeriod.YEAR: {
      const start = momentStart.clone().startOf('year');
      const end = momentEnd.clone().add(1, 'year').startOf('year');
      const startPrev = momentStart.clone().subtract(1, 'year').startOf('year');
      const endPrev = start.clone();
      const amount = momentStart.clone().endOf('year').dayOfYear();
      const amountPrev = momentStart.clone().subtract(1, 'year').endOf('year').dayOfYear();

      return {
        start: start.format(DATE_FORMAT),
        end: end.format(DATE_FORMAT),
        startPrev: startPrev.format(DATE_FORMAT),
        endPrev: endPrev.format(DATE_FORMAT),
        amount,
        amountPrev,
        period: 'day',
        usesSingleApiCall: true,
      };
    }
    case TimePeriod.EIGHT_WEEKS: {
      const { start, end } = getEightWeeksWindow(momentStart);
      const startPrev = start.clone().subtract(8, 'isoWeek');
      const endPrev = start.clone();

      return {
        start: start.format(DATE_FORMAT),
        end: end.format(DATE_FORMAT),
        startPrev: startPrev.format(DATE_FORMAT),
        endPrev: endPrev.format(DATE_FORMAT),
        amount: 8,
        amountPrev: 8,
        period: 'isoWeek',
        usesSingleApiCall: false,
      };
    }
    default:
      return null;
  }
};
